import { Routes, Route } from "react-router-dom";
import ListRentalPlans from "../Components/Resale Plan/rentalPlanList";
import ListVrShootRentalPlan from "../Components/Rental Plan/listVrShootRentalPlan";

const RentalPlanRoutes = () => {
  return (
    <Routes>
      <Route path="/resale_plan" element={<ListRentalPlans />} />
      <Route path="/vr_shoot_rental_plan" element={<ListVrShootRentalPlan />} />
    </Routes>
  );
};

export default RentalPlanRoutes;